import {Controller} from '@hotwired/stimulus';
import tippy, {followCursor} from 'tippy.js';

const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

const ua = navigator.userAgent.toLowerCase();
const isIOS = /ipad|iphone|ipod/.test(ua) && !window.MSStream;

const getTooltipContent = (detailEl) => {
	if (!detailEl) return '';
	const {tooltipStatus, tooltipFloorlabel, tooltipUrl} = detailEl.dataset;

	return `
		<div class="b-building-label b-building-label--floor link-mask">
			${tooltipFloorlabel ? `<span class="b-building-label__name">${tooltipFloorlabel}</span>` : ''}
			<span class="b-building-label__info">
				${tooltipStatus ? `<span>${tooltipStatus}</span>` : ''}
			</span>
			${tooltipUrl ? `<a href="${tooltipUrl}" class="b-building-label__link link-mask__link"><span class="u-vhide">detail</span></a>` : ''}
		</div>
    `;
};

export default class extends Controller {
	static targets = ['label', 'svgLink', 'detail'];

	connect() {
		this.initializeTooltips();
	}

	initialize() {
		this.armedLinks = new WeakMap();
	}

	initializeTooltips() {
		this.svgLinkTargets.forEach((link) => {
			const detailId = link.getAttribute('href')?.replace('#', '');
			const detailEl = this.detailTargets.find((detail) => detail.dataset.tooltipUrl === detailId);

			if (isTouchDevice) {
				if (isIOS === true) {
					this.svgLinkTargets.forEach((link) => {
						link.removeAttribute('data-action');
					});
				}
			}

			if (detailEl) {
				tippy(link, {
					appendTo: isTouchDevice ? () => this.element : undefined,
					content: getTooltipContent(detailEl),
					interactive: isTouchDevice,
					placement: 'right-start',
					arrow: false,
					allowHTML: true,
					animation: false,
					delay: [0, 0],
					followCursor: true,
					plugins: [followCursor],
					theme: 'floorlabel',
					onShow: isTouchDevice
						? (instance) => {
							const handler = () => {
								instance.hide();
								this.svgLinkTargets.forEach((link) => {
									link.classList.remove('is-hovered');
								});
								window.removeEventListener('scroll', handler);
							};
							window.addEventListener('scroll', handler);
						}
						: undefined,
					onClickOutside: () => {
						this.svgLinkTargets.forEach((link) => {
							link.classList.remove('is-hovered');
						});
					},
				});
			}
		});
	}

	handleClick(event) {
		if (isTouchDevice) {
			if (isIOS === true) {
				event.preventDefault();
				this.svgLinkTargets.forEach((link) => {
					link.classList.remove('is-hovered');
				});
				event.target.closest('a').classList.add('is-hovered');
			} else {
				const clickedLink = event.currentTarget;
				if (!this.armedLinks.get(clickedLink)) {
					event.preventDefault();

					document.querySelectorAll('a[data-action*="handleClick"]').forEach((link) => {
						this.armedLinks.set(link, false);
					});

					this.svgLinkTargets.forEach((link) => {
						link.classList.remove('is-hovered');
					});

					event.target.closest('a').classList.add('is-hovered');
					this.armedLinks.set(clickedLink, true);
				}
			}
		}
	}
}
